// extracted by mini-css-extract-plugin
export var container = "Gallery-module--container---6x5K";
export var desc = "Gallery-module--desc--TC23u";
export var gallery = "Gallery-module--gallery--Qes-q";
export var lineLink = "Gallery-module--line-link--tUrIi";
export var lineLink_black = "Gallery-module--line-link_black--4dBOq";
export var lineLink_grey = "Gallery-module--line-link_grey--m1Hfs";
export var lineLink_primary = "Gallery-module--line-link_primary--3Ed5G";
export var lineLink_secondary = "Gallery-module--line-link_secondary--Clxi8";
export var lineLink_white = "Gallery-module--line-link_white--rNrSy";
export var zoom = "Gallery-module--zoom--lTp0Y";